import { HomePage } from 'pages/HomePage'
import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import Styles from './App.module.css'
import { pushToast, Toast } from 'store/toast'
import { readConfig } from 'store/config'
import { showModal } from 'store/modal'
import { loginCookie } from './store/profile'

interface AppProps {
	pushToast: (toast: Toast) => void;
	readConfig: () => Promise<boolean>;
	showModal: typeof showModal;
	loginCookie: () => Promise<string | void>;
}

interface AppState {
	configured: boolean
}

class App extends React.Component<AppProps, AppState> {
	constructor(props: AppProps) {
		super(props)
		this.state = {
			configured: false
		}
	}

	componentDidMount = async (): Promise<void> => {
		const configRead = await this.props.readConfig()

		await this.props.loginCookie()

		this.setState({
			configured: configRead
		})
	}

	render(): React.ReactNode {
		const { configured } = this.state

		if (!configured) {
			return null
		}

		return (
			<div className={Styles.container}>
				<Route path='/' component={HomePage} />
			</div>
		)
	}
}

export default connect(undefined, { pushToast, readConfig, showModal, loginCookie })(App)
